import { Carousel } from "bootstrap";

const homeCarousel = document.querySelector("#home-carousel");
const homeCarouselAlbum = document.querySelector("#home-carousel-album");
const homeCarouselSmallAlbum = document.querySelector(
  "#home-carousel-small-album"
);

new Carousel(homeCarousel, { interval: 3000 });
new Carousel(homeCarouselAlbum, { wrap: false, ride: false });
new Carousel(homeCarouselSmallAlbum, { wrap: false, ride: false });
